<template>
  <div class="tasks--main" :class="$isMobile ? 'tasks--container--mobile' : ''">
    <TasksCloseButton />
    <div class="tasks--title" :class="$isMobile ? 'tasks--title--mobile' : ''">
      <div>Tasks</div>
    </div>
    <div v-if="loadingTasks && !firstLoadDone" class="tasks--info--text" :class="$isMobile ? 'tasks--info--mobile' : ''">Loading tasks...</div>
    <div v-else-if="!tasks.length && !loadingTasks" class="tasks--info--text" :class="$isMobile ? 'tasks--info--mobile' : ''">No tasks, add one!</div>
    <div v-else-if="tasks && tasks.length && firstLoadDone" class="tasks--container" id="dropdown-tasks">
      <div v-for="(item, index) in sortedTasks" :key="index" class="tasks--item">
        <!-- Card checkbox -->
        <div
          class="itemsListCard--check"
          :class="item.complete ? 'itemsListCard--check-complete' : ''"
          v-if="item.type === 'TASK'"
          @click.stop="toggleComplete(item)"
        >
          <div class="itemsListCard--check-icon" v-show="item.complete">
            <IconCheckmark />
          </div>
        </div>
        <span class="tasks--item--content" :class="item.complete ? 'tasks--item--content--strike' : ''">{{ item.name }}</span>
        <div class="tasks--item--delete" @click="deleteTask(item)">
          <IconBase icon-name="trash" iconColor="#444" viewBox="-57 0 512 512" width="100%" height="100%" strokeWidth="0px"><IconTrash /></IconBase>
        </div>
        <!-- <div class="delete-actions">
          <div>Cancel</div>
          <div>Delete</div>
        </div> -->
      </div>
      <InfiniteLoading v-if="!allLoaded" @infinite="loadMoreTasks" spinner="spiral">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </InfiniteLoading>
    </div>
    <div class="tasks--bottom--container">
      <input
        class="tasks--input"
        id="taskInput"
        placeholder="Write 300 words, organize inbox, read 20 pages, etc."
        @keyup.enter="createNewTask"
        autocomplete="off"
        v-model="task"
      />
    </div>
    <!-- <div class="dropdown-item expand">
      <div @click="toggleQuickAdd" class="expand-button">Expand</div>
    </div> -->
  </div>
</template>

<!-- When user does have rooms, there can be a quick entry by displaying some of the rooms as some sort of circles on a separate row, which have an image or letter & it is scrollable, maybe expandable, it is still under 'My rooms' title.-->

<script>
import { mapState } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import IconBase from "@/components/IconBase";
import IconTrash from "@/components/SVG/IconTrash";

import ItemAPI from "../../../ELYX/Items/ItemAPI";
import TasksCloseButton from "./TasksCloseButton.vue";
import IconCheckmark from "../../../components/SVG/IconCheckmark.vue";

import TasksStore from "./TasksStore.js";

export default {
  name: "Tasks",
  data() {
    return {
      loadingTasks: true,
      fetchError: false,
      addingTask: false,

      options: {
        sort: -1, // 1 or -1 Default sort is chronologically first item first
        limit: 15, // Default get 20 items at a time
        skip: 0, // Change per round of queries
      },

      allLoaded: false,
      firstLoadDone: false,
    };
  },
  components: {
    IconBase,
    IconTrash,
    TasksCloseButton,
    IconCheckmark,
    InfiniteLoading,
  },
  created() {
    this.getTasks();
  },

  beforeDestroy() {
    TasksStore.methods.clearTasks();
    TasksStore.methods.setTask("");
    this.allLoaded = false;
    this.firstLoadDone = false;
    this.options.skip = 0;
    this.loadingTasks = true;
    this.fetchError = false;
    this.addingTask = false;
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    tasks: () => TasksStore.state.tasks,
    sortedTasks() {
      let tasks = this.tasks;
      return tasks.sort(function (a, b) {
        let dateA = new Date(a.createdMS);
        let dateB = new Date(b.createdMS);
        return dateB - dateA;
      });
    },
    task: {
      get() {
        return TasksStore.state.task;
      },
      set(value) {
        TasksStore.methods.setTask(value);
      },
    },
  },
  methods: {
    async toggleComplete(item) {
      /** If not dealing with an item of type task, cancel complete */
      if (item.type !== "TASK") return;

      if (!item.complete) {
        /** If item is not set to complete, then set it to complete
         * in the local data store for fast UX. */
        TasksStore.methods.completeOneItemByID(item._id);

        /** Then make request to set item as complete in the database. */
        const response = await ItemAPI.completeItemByID(this.user._id, item._id);

        /** If anything goes wrong with the request, revert item complete status. */
        if (!response || !response.success) {
          TasksStore.methods.uncompleteOneItemByID(item._id);
        }
      } else {
        /** If item is set to complete, then set it to uncomplete
         * in the local data store for fast UX. */
        TasksStore.methods.uncompleteOneItemByID(item._id);

        /** Then make request to set item as uncomplete in the database. */
        const response = await ItemAPI.uncompleteItemByID(this.user._id, item._id);

        /** If anything goes wrong with the request, revert item complete status. */
        if (!response || !response.success) {
          TasksStore.methods.completeOneItemByID(item._id);
        }
      }
    },

    toggleQuickAdd() {
      TasksStore.methods.toggleQuickAdd();
    },

    scrollTasksToTop() {
      var tasks = document.getElementById("dropdown-tasks");
      tasks.scrollTop = 0;
    },

    async getTasks() {
      let items = [];
      this.loadingTasks = true;
      const spaceID = "unset";
      const filters = { type: "TASK" };
      items = await ItemAPI.getItems(this.user._id, spaceID, this.options, filters);
      this.loadingTasks = false;
      if (items && items.length) {
        TasksStore.methods.setAllTasks(items);
        this.options.skip = this.tasks.length;
        if (items.length < this.options.limit) {
          this.allLoaded = true;
        }
      } else {
        /* ========== All items loaded for this property. ==========
         * NB! Don't use InfiniteLoading's $state.complete() because it
         * then won't load more in case you switch tags and need to load
         * more there. */
        this.allLoaded = true;
      }
      this.firstLoadDone = true;
    },

    async loadMoreTasks($state) {
      await this.$nextTick();

      if (this.allLoaded) {
        $state.loaded();
      }

      try {
        let items = [];
        this.loadingTasks = true;
        const spaceID = "unset";
        const filters = { type: "TASK" };
        items = await ItemAPI.getItems(this.user._id, spaceID, this.options, filters);
        this.loadingTasks = false;

        if (items && items.length) {
          TasksStore.methods.setAllTasks(items);
          this.options.skip = this.tasks.length;
          $state.loaded();
        } else {
          /* ========== All items loaded for this property. ==========
           * NB! Don't use InfiniteLoading's $state.complete() because it
           * then won't load more in case you switch tags and need to load
           * more there. */
          this.allLoaded = true;
          $state.loaded();
        }
      } catch (error) {
        this.fetchError = true;
      }
    },

    async createNewTask() {
      if (!this.task) {
        return;
      }
      this.addingTask = true;
      try {
        const itemData = { name: this.task, type: "TASK", spaceID: "unset" };
        const response = await ItemAPI.createOneItem(this.user._id, itemData);
        if (!response || !response.success || !response.data) {
          throw new Error("Failed to create item.");
        }
        this.addingTask = false;
        this.task = "";
        TasksStore.methods.setTask("");
        let task = response.data;
        TasksStore.methods.addTask(task);
        this.scrollTasksToTop();
      } catch (error) {
        this.fetchError = true;
      }
    },

    async deleteTask(task) {
      console.log("DELETED TASK!", task);
      if (!task) return;

      const itemID = task._id;

      try {
        const response = await ItemAPI.deleteOneItem(this.user._id, itemID);
        if (!response || !response.success) {
          throw new Error("Failed to delete task");
        }

        TasksStore.methods.removeTask(itemID);
      } catch (error) {
        this.fetchError = true;
      }
    },
  },
};
</script>

<style scoped>
@import "./styles/Dropdown.css";
.tasks--main {
  transition: 0.2s ease-in-out;
  cursor: default;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border-color: transparent;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  overflow-y: scroll;
  border-radius: 12px;
  margin-bottom: 17px;
  margin-top: 20px;
  background-color: #ffffff !important;
  min-width: 364px;
  max-width: 364px;
  margin-right: 10px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: absolute;
  right: 16px;
  top: 55px;
  height: calc(100% - 92px);
  border: 1px solid transparent;
  z-index: 10001;
}
.tasks--info--text {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 100%;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.tasks--info--text::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.tasks--info--text {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.tasks--title {
  margin: 10px auto;
  width: 180px;
  padding: 8px 15px;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: 360px;
  font-weight: 600;
  color: #323333;
  text-align: center;
}
.tasks--container {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  box-sizing: border-box;
}
.tasks--item {
  margin: 2px 15px;
  font-size: 16px;
  border: 1px solid transparent;
  font-weight: 400;
  color: #323333;
  word-break: break-word;
  position: relative;
  border-radius: 12px;
  transition: 0.1s ease-in-out;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255);
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
}

.tasks--item--delete {
  position: absolute;
  width: 16px;
  height: 16px;
  right: 10px;
  top: calc(50% + -1px);
  transform: translateY(-50%);
  bottom: 0px;
  z-index: 50;
  padding: 5px;
  border-radius: 360px;
  cursor: pointer;
  display: none;
}
.tasks--item--delete:hover {
  background-color: #e9e9ea;
}

.tasks--item:hover .tasks--item--delete {
  display: block;
}

.tasks--input {
  border-radius: 12px;
  font-size: 16px;
  font-family: "Nunito", sans-serif;
  transition: 0.2s ease;
  box-sizing: border-box;
  outline: none;
  margin: 0 15px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255);
  border: 1px solid transparent;
  margin-top: auto;
  padding: 15px 15px;
}

.setting-input:hover {
  border-color: #ccc;
}

.setting-input:focus {
  border-color: #ccc;
}
.tasks--container--mobile {
  width: 100%;
  max-width: 100%;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  height: calc(100% - 45px);
  border-radius: 0px;
  background: var(--calendar-background-color);
  background-size: 100% 100%;
  padding-bottom: 0px;
  background-repeat: no-repeat;
  border: none;
}
.tasks--bottom--container {
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-top: 1px solid #efefef;
}
.tasks--addNew {
  margin: 10px auto;
  width: 95%;
  font-size: 16px;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid transparent;
  font-weight: 500;
  color: white;
  word-break: break-word;
  position: relative;
  border-radius: 360px;
  transition: 0.1s ease-in-out;
  text-align: center;
  background-color: black;

  padding: 8px 15px;
}
.tasks--info--mobile {
  height: 100%;
  font-weight: 500;
}

.tasks--title--mobile {
  margin: 10px auto;
}

/* ========== CHECKBOX ========== */
.itemsListCard--check {
  border-radius: 360px;
  width: 28px;
  height: 28px;
  color: #a7a7a7ba;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  flex-shrink: 0;
}
.itemsListCard--check-complete {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%),
    radial-gradient(at top center, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.4) 120%) #646464;
  background-blend-mode: multiply, multiply;
}
.itemsListCard--check-icon {
  color: white;
  width: 14px;
  height: 14px;
}
.tasks--item--content {
  padding: 0px 10px;
  line-height: 20px;
}
.tasks--item--content--strike {
  text-decoration: line-through;
  color: #a7a7a7ba;
}
</style>
